import { useQuery } from 'react-query';
import { queryConsultationSummary } from './useConsultationSummary.query';
import {
  ConsultationSummaryResponse,
  UseConsultationSummaryOptions,
} from './useConsultationSummary.types';

export const CONSULTATION_SUMMARY_QUERY_KEY = 'CONSULTATION_SUMMARY';

export const useConsultationSummary = (
  consultationId: number,
  options?: UseConsultationSummaryOptions
) => {
  return useQuery<ConsultationSummaryResponse, Error>(
    CONSULTATION_SUMMARY_QUERY_KEY,
    () => queryConsultationSummary(consultationId),
    {
      retry: false,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};
